import React from "react";
import "./ListWithDeleteOption.css";

interface Props<T> {
  items: T[];
  getKey: (item: T) => string;
  renderItem: (item: T) => React.ReactNode;
  onRemove: (item: T) => void;
  emptyMessage?: string;
}

function ListWithDeleteOption<T>({
  items,
  getKey,
  renderItem,
  onRemove,
  emptyMessage = "No items.",
}: Props<T>) {
  if (items.length === 0) {
    return <span className="lwdo-empty">{emptyMessage}</span>;
  }

  return (
    <ul className="lwdo-list">
      {items.map((item) => (
        <li key={getKey(item)} className="lwdo-item">
          <span className="lwdo-content">{renderItem(item)}</span>
          <button
            type="button"
            className="lwdo-delete"
            onClick={() => onRemove(item)}
            aria-label="Remove item"
          >
            <i className="pi pi-times" />
          </button>
        </li>
      ))}
    </ul>
  );
}

export default ListWithDeleteOption;
